import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

const pageVariants = {
  initial: { opacity: 0, x: 50 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -50 },
};

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

export const WelcomeStep = ({ user, onNext }) => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4"
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", duration: 0.6 }}
        className="w-24 h-24 flex items-center justify-center mb-8"
      >
        <Logo size="xl" />
      </motion.div>

      <motion.h1
        variants={fadeInUp}
        className="text-4xl sm:text-5xl font-bold text-foreground mb-4"
      >
        {t("onboarding.welcome.title", "Welcome to eScribe")}
        {user?.firstName && `, ${user.firstName}`}!
      </motion.h1>

      <motion.p
        variants={fadeInUp}
        className="text-xl text-muted-foreground max-w-2xl mb-8"
      >
        {t(
          "onboarding.welcome.subtitle",
          "The modern way to sign documents. Let's get you started in just a few steps.",
        )}
      </motion.p>

      <motion.div variants={fadeInUp}>
        <Button size="lg" onClick={onNext} className="gap-2 text-lg px-8">
          {t("onboarding.welcome.getStarted", "Get Started")}
          <ArrowRight className="w-5 h-5" />
        </Button>
      </motion.div>

      <motion.p
        variants={fadeInUp}
        className="text-sm text-muted-foreground mt-6"
      >
        {t("onboarding.welcome.time", "This will only take about 2 minutes")}
      </motion.p>
    </motion.div>
  );
};

export default WelcomeStep;
